<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý gói dịch vụ</div>
      </div>
      <div class="card card-w-title" v-if="display_page" >
        <div class="box-top-list">
          <span class="p-m-0">{{ (formMode=='edit') ? 'Chỉnh sửa gói dịch vụ':'Tạo mới gói dịch vụ' }} </span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList"/>
            <Button :disabled="submitForm" class="p-button-success btn-custom" :label="labelName" @click="saveData"/>
          </span>
          <div class="clearfix"></div>
        </div>
        <div class="list-data-permission">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-12">
                <label for="name" class="style_lable">Mã gói dịch vụ<span class="error">*</span></label>
                <InputText  id="code" type="text" v-model="objectData.code"/>
                <small v-if="validationErrors && validationErrors['code']"
                       class="p-invalid">{{ validationErrors['code'] }}</small>
              </div>
              <div class="p-col-12">
                <label for="name" class="style_lable">Tên gói dịch vụ<span class="error">*</span></label>
                <InputText id="name" type="text" v-model="objectData.name"/>
                <small v-if="validationErrors && validationErrors['name']"
                       class="p-invalid">{{ validationErrors['name'] }}</small>
              </div>
              <div class="p-col-12">
                <div class="p-grid">
                  <div class="p-col-12">
                    <div class="p-field">
                      <div class="p-field-checkbox">
                        <Checkbox v-model="objectData.status" :binary="true"/>
                        <label>Hiển thi sử dụng</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-col-12">
                <label for="name" class="style_lable">Model sản phẩm áp dụng gói dịch vụ<span class="error">*</span></label>
                <div class="group_radio_button">
                  <div class="p-field-radiobutton radio_product_apply">
                    <RadioButton id="product_apply_1" name="city" value="1" v-model="objectData.apply_all_model"/>
                    <label for="product_apply_1" class="radio_lable_product_apply">Tất cả model sản phẩm</label>
                  </div>
                  <div class="p-field-radiobutton radio_product_apply" style="margin-top: 8px;">
                    <RadioButton id="product_apply_2" name="city" value="0" v-model="objectData.apply_all_model"/>
                    <label for="product_apply_2" class="radio_lable_product_apply">Thiết lập danh sách model sản
                      phẩm</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-12">
                <label class="style_lable">Mô tả</label>
                <Textarea id="description" rows="7" v-model="objectData.description" :autoResize="true"/>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6" v-if="objectData.apply_all_model == '0'">
              <div class="p-col-12">
                <!--<label for="name">Danh sách vật tư - dịch vụ sửa chữa<span class="error">*</span></label>-->
                <form v-on:submit.prevent="noop">
                <div class="p-fluid p-formgrid p-grid box_add_option" style="">
                  <div class="box_input" style="">
                    <div class="p-field box_title" style="">
                      <label class="title_input" style="">Model sản phẩm</label>
                      <!--<a  href="#"><label class="add_service_supplies" style="">+ Tạo mới vật tư - dịch vụ</label></a>-->
                    </div>
                    <Dropdown class="width-300" :filter="true" v-model="selected_product"
                              :options="list_dropdown_product" optionLabel="label" placeholder="Chọn model sản phẩm"/>
                    <!--<Dropdown style="height: 30px" inputId="unit" v-model="city" :options="list_unit" optionLabel="label"  optionValue="value" placeholder="Chọn đơn vị tính"/>-->
                  </div>
                  <button class="add_btn_data" @click="add_model_product()">
                    <img class="style_icon_add" style="" src="../../../../public/assets/images/playlist_add_u605.png"/>
                    <span class="style_text" style="">Thêm</span>
                  </button>
                </div>
                </form>
              </div>
              <small style="padding-left: 15px" v-if="validationErrors && validationErrors['list_product']"
                     class="p-invalid">{{ validationErrors['list_product'] }}</small>
            </div>
            <div class="p-field p-col-12 p-md-12" v-if="objectData.apply_all_model == '0'">
              <div class="p-col-12">
                <BaseCommonList
                    :countCheckBox="true"
                    :labelHeaderAction="'Chi tiết'"
                    :key="listModelProduct.componentKey"
                    :listData="listModelProduct.listData"
                    :model="listModelProduct.dataModel"
                    :filterDefault="listModelProduct.filters"
                    v-on:action-click="onActionClickedModelProduct"
                    :actions="getRowActionsModelProduct()"
                    :pagination="true"
                ></BaseCommonList>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-12">
                <label for="name" class="style_lable">Danh sách vật tư - dịch vụ sửa chữa<span class="error">*</span></label>
                <form v-on:submit.prevent="noop">
                <div class="p-fluid p-formgrid p-grid box_add_option" style="">
                  <div class="box_input" style="">
                    <div class="p-field box_title" style="">
                      <label class="title_input" style="">Vật tư - dịch vụ</label>
                      <a href="#"
                         v-on:click="onActionClickedAddServiceSupplies($event,{action: {name: 'add', label: 'Tạo mới'}, key: 'add'})"><label
                          class="add_service_supplies" style="">+ Tạo mới vật tư - dịch vụ</label></a>
                    </div>
                    <Dropdown class="width-300" :filter="true" v-model="selected_service_supplies"
                              :options="list_dropdown_service_supplies" optionLabel="label"
                              placeholder="Chọn vật tư hoặc dịch vụ"><!--optionValue="id" -->
                    </Dropdown>
                  </div>
                  <button class="add_btn_data" style="" @click="add_service_supplies()">
                    <img class="style_icon_add" style="" src="../../../../public/assets/images/playlist_add_u605.png"/>
                    <span class="style_text" style="">Thêm</span>
                  </button>
                </div>
                </form>
              </div>
              <small style="padding-left: 15px" v-if="validationErrors && validationErrors['list_service_supplies']"
                     class="p-invalid">{{ validationErrors['list_service_supplies'] }}</small>
            </div>
            <div class="p-field p-col-12 p-md-12">
              <div class="p-col-12 list_service_supplies">
                <!--:classDatatable="'service_park_ss'"   thêm class phẩn biệt để hiển th5i số lượng-->
                <BaseCustomList
                    :classDatatable="'service_park_ss'"
                    :countCheckBox="true"
                    :labelHeaderAction="'Chi tiết'"
                    :key="componentKeyServiceSupplies"
                    :listData="listDataServiceSupplies"
                    :model="dataModelServiceSupplies"
                    :filterDefault="filtersServiceSupplies"
                    v-on:action-click="onActionClickedServiceSupplies"
                    :actions="getRowActionsServiceSupplies()"
                    :pagination="true"
                ></BaseCustomList>
              </div>
            </div>
            <PopupServiceSupplies
                v-if="PopupServiceSupplies.editDialogKey > 0"
                :key="PopupServiceSupplies.editDialogKey"
                :show="PopupServiceSupplies.displayDialog"
                :mode="PopupServiceSupplies.dialogMode"
                :model="PopupServiceSupplies.modelEdit"
                :modelName="PopupServiceSupplies.modelName"
                :screen="'service_park'"
                @save_service_supplies="save_service_supplies"
            ></PopupServiceSupplies><!--@refresh="refreshData"-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommonList from '../common'
import BaseCustomList from './list_custom'
import PopupServiceSupplies from '../service_supplies/popup'
//import Module from './module'
export default {
  components: {
    //  Module
    BaseCommonList,
    PopupServiceSupplies,
    BaseCustomList,
  },
  data() {
    return {
      modelPermissionData: [],
      dataModel: null,
      componentKey: 0,
      modelName: 'roles',
      name: '',
      description: '',
      activeIndex: 0,
      validationErrors: {},
      name_exists: false,
      roleID: 0,
      permissonAllWeb: [],
      permissonAllMobile: [],
      type: 'web',
      submitForm: false,
      is_management_lower_level: false,
      status: true,
      labelName: 'Tạo',
      titleModel: ' Tạo mới gói dịch vụ',
      city: null,
      dataModelServiceSupplies: null,
      listDataServiceSupplies: [],
      listOldServiceSupplies: [],
      componentKeyServiceSupplies: 0,
      filtersServiceSupplies: {},
      list_dropdown_service_supplies: [],
      selected_service_supplies: null,
      list_dropdown_product: [],
      selected_product: null,
      objectData: {
        code: '',
        name: '',
        description: '',
        status: true,
        apply_all_model: '1',//SỬ dụng kiểu string mới active dc radio
      },
      PopupServiceSupplies: {
        editDialogKey: 0,
        displayDialog: false,
        dialogMode: 'add',
        modelEdit: {},
        modelName: 'service_supplies',
      },
      listModelProduct: {
        componentKey: 0,
        listData: [],
        listOld: [],
        dataModel: null,
        filters: {},
      },
      formMode: 'add',
      display_page:true
    }
  },
  async created() {
    await this.initData();
  },
  async mounted() {
    /*this.dataModel = DataServices.getModel(this.modelName);
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      this.roleID = Number(this.$route.params.id);
      await this.getData();
    }*/
  },
  methods: {
    noop () {
      //Chặn redirect submit form
      return false;
    },
    add_model_product() {
      if (!this.selected_product) {
        //alert("Vui lòng chọn");
        this.validationErrors['list_product'] = 'Vui lòng thêm model sản phẩm áp dụng cho gói dịch vụ vào danh sách';
        this.$forceUpdate();
        return false;
      }
      this.validationErrors['list_product'] = '';
          this.listModelProduct.listData.unshift(this.selected_product);//push đầu dòng
      this.selected_product = null;
      var list_id = [];
      for (var i = 0; i < this.listModelProduct.listData.length; i++) {
        list_id.push(this.listModelProduct.listData[i].id);
      }
      this.getOptionProducts(list_id);
      this.listModelProduct.componentKey++;

    },
    async getOptionProducts(not_in_id = []) {
      var vm = this;
      var where = {
        status: {'_in': [1]},
        production_status: {'_eq': 1},
        categories: {
          status: {'_eq': 1}
        }
      };
      if (not_in_id.length > 0) {
        where.id = {'_nin': not_in_id};
      }
      var variables = {
        where_key: where,
        orderBy: {
          name: 'asc',
          created_date: 'desc'
        }
      }
      var data = await DataServices.getList('product', {
        "variables": JSON.stringify(variables),
        "fields": 'id name model_code'
      });
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          var pro = list[index];
          var code = (!vm.$myConstants.isEmpty(pro.model_code)) ? pro.model_code : '';
          var name = (!vm.$myConstants.isEmpty(pro.name)) ? pro.name : '';
          list[index].label = code + ' - ' + name;
        }
        this.list_dropdown_product = this.$myConstants.convertJsonObject(list);
      } else {
        this.list_dropdown_product = [];
      }
    }
    ,
    add_service_supplies() {
      if (!this.selected_service_supplies) {
        this.validationErrors['list_service_supplies'] = 'Vui lòng thêm vật tư - dịch vụ sửa chữa vào danh sách';
        this.$forceUpdate();
        return false;
      }
      //vm.$myConstants.numberFormat(item_data.unit_price, 0, '', '.')
      this.validationErrors['list_service_supplies'] = '';
      //console.log("this.selected_service_supplies:",this.selected_service_supplies)
      var data_add = this.$myConstants.convertJsonObject(this.selected_service_supplies);
      data_add.unit_price = (!this.$myConstants.isEmpty(data_add.unit_price)) ? this.$myConstants.numberFormat(data_add.unit_price, 0, '', '.'):0;
      this.listDataServiceSupplies.unshift(data_add);//push đầu dòng
      this.selected_service_supplies = null;
      var list_id = [];
      for (var i = 0; i < this.listDataServiceSupplies.length; i++) {
        list_id.push(this.listDataServiceSupplies[i].id);
      }
      this.loadSelectServiceSupplies(list_id);
      this.componentKeyServiceSupplies++;

    },
    save_service_supplies() {
      this.$toast.add({severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000})
      this.PopupServiceSupplies.displayDialog = false;
      this.PopupServiceSupplies.editDialogKey = Math.floor(Math.random() * (30))
      //load data
      var list_id = [];
      for (var i = 0; i < this.listDataServiceSupplies.length; i++) {
        list_id.push(this.listDataServiceSupplies[i].id);
      }
      this.loadSelectServiceSupplies(list_id);
      this.componentKeyServiceSupplies++;
    },
    onActionClickedAddServiceSupplies(event, payload) {
      var action = payload.action
      event.preventDefault();
      /*if (payload.data) {
        data = payload.data
      }*/
      switch (action.name) {
        case 'add':
          //  if (this.checkVisible('service_supplies', 'add')) {
          this.PopupServiceSupplies.displayDialog = true
          this.PopupServiceSupplies.editDialogKey = Math.floor(Math.random() * (30))
          //}
          break;
      }

    },
    onActionClickedServiceSupplies(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path})
          } else {
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30))
          }
          break;
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path + data.data[action.key]})
          } else {
            this.modelEdit = data.data;
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30));
          }
          break;
        case 'delete':
          var id_delete = data.data.id;
          var key_delete = null
          var list_id = [];
          for (var i = 0; i < this.listDataServiceSupplies.length; i++) {
            if (parseFloat(id_delete) == parseFloat(this.listDataServiceSupplies[i].id)) {
              key_delete = i;
            } else {
              list_id.push(this.listDataServiceSupplies[i].id);
            }
          }
          if (!this.$myConstants.isEmpty(key_delete)) {
            this.listDataServiceSupplies.splice(key_delete, 1);
          }
          //load lại option
          this.loadSelectServiceSupplies(list_id);
          this.componentKeyServiceSupplies++;
          break;
      }
    },
    getRowActionsServiceSupplies() {
      var actions = {}
      //var that = this;
      actions.filter = {name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        console.log(rowData)
        /*buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/appraisal-product/view-detail`}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }*/
        buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
        return buttons
      }
      return actions
    },
    onActionClickedModelProduct(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path})
          } else {
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30))
          }
          break;
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path + data.data[action.key]})
          } else {
            this.modelEdit = data.data;
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30));
          }
          break;
        case 'delete':
          var id_delete = data.data.id;
          var key_delete = null
          var list_id = [];
          for (var i = 0; i < this.listModelProduct.listData.length; i++) {
            if (parseFloat(id_delete) == parseFloat(this.listModelProduct.listData[i].id)) {
              key_delete = i;
            } else {
              list_id.push(this.listModelProduct.listData[i].id);
            }
          }
          if (!this.$myConstants.isEmpty(key_delete)) {
            this.listModelProduct.listData.splice(key_delete, 1);
          }
          //load lại option
          this.getOptionProducts(list_id);
          //this.componentKeyServiceSupplies++;
          this.listModelProduct.componentKey++;
          break;
      }
    },
    getRowActionsModelProduct() {
      var actions = {}
      //var that = this;
      actions.filter = {name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        console.log(rowData)
        /*buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/appraisal-product/view-detail`}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }*/
        buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
        return buttons
      }
      return actions
    },
    async loadSelectServiceSupplies(not_in_id = []) {
      var vm = this;//service_supplies_form
      var where =  {
        status: {'_in': [1]},//0,
      };
      if (not_in_id.length > 0){
        where.id = {'_nin': not_in_id}
      }
      var variables_service_supplies = {
        where_key:where,
        orderBy: {
          id: 'desc'
        }
      }
      //load danh sách vật tư
      DataServices.getListData('service_supplies', {"variables": JSON.stringify(variables_service_supplies)}).then(async (res_list) => {
        if (res_list.length > 0) {
          for (var i = 0; i < res_list.length; i++) {
            var code = (!vm.$myConstants.isEmpty(res_list[i].code)) ? res_list[i].code : '';
            var name = (!vm.$myConstants.isEmpty(res_list[i].name)) ? res_list[i].name : '';
            var unit_price = (!vm.$myConstants.isEmpty(res_list[i].unit_price)) ? vm.$myConstants.numberFormat(res_list[i].unit_price, 0, '', '.') + 'đ' : '0đ';
            res_list[i].label = code + ' - ' + name + ' - ' + unit_price;
          }
          vm.list_dropdown_service_supplies = vm.$myConstants.convertJsonObject(res_list);
        } else {
          vm.list_dropdown_service_supplies = [];
        }

      }).catch(async () => {

      });
    }
    ,
    async initData() {
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      var vm = this;
      this.modelName = 'service_park';
      var service_pack_id = 0;
      if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
        if (!vm.$myConstants.checkRoleGroup('service_park', 'edit')){
          vm.display_page = false;
        }
        this.labelName = 'Lưu';
        this.formMode = 'edit';
        service_pack_id = this.$route.params.id;
        //get data service pack
        var whereObject = {
          id: {'_eq': service_pack_id}
        }
        DataServices.getObjectData('service_park', whereObject, {id: 'desc'}).then(async (resObj) => {
          if (resObj.creator_organization_id != creator_organization_id){
            vm.display_page = false;
          }
          vm.objectData = vm.$myConstants.convertJsonObject(resObj);
          vm.objectData.apply_all_model = resObj.apply_all_model.toString();//radio button phải convert sang string
        }).catch(async () => {
          vm.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
            life: 3000
          });
        });
      }else {
        if (!vm.$myConstants.checkRoleGroup('service_park', 'add')){
          vm.display_page = false;
        }
      }
      //load data list product
      this.listModelProduct.dataModel = DataServices.getModel('product_from_service_pack');//model tạm để hiển thị list
      var variables_model_product = {
        where_key: {
          obj_product:{
            status: {'_in': [1]},
            production_status: {'_eq': 1},
            categories: {
              status: {'_eq': 1}
            }
          },
          service_pack_id: {_eq: service_pack_id},
          status: {_eq: 1}
        },
        orderBy: {"id": "desc"}
      }
      //sử dụng data bảng service_pack_product
      DataServices.getList('service_pack_product', {"variables": JSON.stringify(variables_model_product)}).then(async (data) => {
        var list = data[Object.keys(data)];
        //Lấy list id cũ để kiểm tra update
        var list_data = [];
        for (var i = 0; i < list.length; i++) {
          var data_obj = {
            id:list[i].obj_product.id,
            model_code:list[i].obj_product.model_code,
            name:list[i].obj_product.name,
          };
          list_data.push(data_obj);
          vm.listModelProduct.listOld.push(list[i].obj_product.id);
        }
        vm.listModelProduct.listData = list_data;
        vm.listModelProduct.componentKey++;
        if (this.formMode == 'edit'){
          this.getOptionProducts(vm.listModelProduct.listOld);
        }else {
          //load option product
          this.getOptionProducts();
        }
      }).catch(async () => {
        vm.listModelProduct.listData = [];
      });


      //var vm = this;
      this.dataModelServiceSupplies = DataServices.getModel('service_supplies_form');

      var variables = {
        where_key: {
          obj_service_supplies: {
            status: {'_in': [1]},//0,
          },
          service_pack_id: {_eq: service_pack_id},
          status: {_eq: 1}
        },
        orderBy: {
         /* modified_date: 'desc_nulls_first',*/
          id: 'desc'
        }
      }
      DataServices.getList('service_pack_service_supplies', {"variables": JSON.stringify(variables)}).then(async (data) => {
        var list = data[Object.keys(data)];
        vm.componentKeyServiceSupplies++;
        var list_data = [];
        //Lấy list id cũ để kiểm tra update
        for (var i = 0; i < list.length; i++) {
          var item_data = list[i].obj_service_supplies;
          var data_obj = {
            id:(!vm.$myConstants.isEmpty(item_data.id) ? item_data.id:''),
            code:(!vm.$myConstants.isEmpty(item_data.code) ? item_data.code:''),
            name:(!vm.$myConstants.isEmpty(item_data.name) ? item_data.name:''),
            unit:(!vm.$myConstants.isEmpty(item_data.unit) ? item_data.unit:''),
            unit_price:(!vm.$myConstants.isEmpty(item_data.unit_price) ? vm.$myConstants.numberFormat(item_data.unit_price, 0, '', '.'):0),
          };
          list_data.push(data_obj);
          vm.listOldServiceSupplies.push(item_data.id);
        }
        vm.listDataServiceSupplies = list_data;
        vm.componentKeyServiceSupplies++;
        //load select
        if (this.formMode == 'edit'){
          this.loadSelectServiceSupplies(vm.listOldServiceSupplies)
        }else {
          this.loadSelectServiceSupplies([])
        }
      }).catch(async () => {
        vm.listDataServiceSupplies = [];
      });

    },
    async getData() {
      var variables = {
        where_key: {
          id: {'_eq': this.roleID}
        }
      }
      var data = await DataServices.getList(this.modelName, {
        "variables": JSON.stringify(variables),
        "fields": "id name description is_management_lower_level status role_permission(where: {status: {_eq: 1} }) { id role_id permission_id permission { type }}"
      });
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        this.labelName = 'Lưu';
        this.titleModel = 'Chỉnh sửa quyền truy cập';
        var model = list[0];
        this.modelPermissionData = model;
        this.name = model.name;
        this.description = model.description;
        this.is_management_lower_level = model.is_management_lower_level;
        this.status = model.status;
        var modelData = (model.role_permission != undefined && model.role_permission != null) ? model.role_permission : [];
        if (modelData) {
          for (let index = 0; index < modelData.length; index++) {
            const item = modelData[index];
            if (item.permission != undefined & item.permission != null && item.permission.type != undefined && item.permission.type != '') {
              if (item.permission.type == 'web') this.permissonAllWeb[item.permission_id] = true;
              else if (item.permission.type == 'mobile') this.permissonAllMobile[item.permission_id] = true;
            }
          }
        }
      }
      this.componentKey = Math.random() * 1020;
    },
    backList() {
      this.$router.push({path: '/admin/service-park'});
    },
    async clickChange($event) {
      this.activeIndex = parseInt($event.tab.$vnode.data.key);
      await this.getData();
    },
    changeChecked(payload) {
      if (payload.type == 'web') {
        this.permissonAllWeb = payload.lists;
      } else if (payload.type == 'mobile') {
        this.permissonAllMobile = payload.lists;
      }
    },
    async checkName() {
      this.name = this.name.trim();
      if (this.name !== undefined && this.name !== "") {
        var where = {name: {'_ilike': this.name}}
        if (this.modelPermissionData != null) where = Object.assign(where, {id: {'_neq': this.modelPermissionData.id}})
        var data = await DataServices.getList(this.modelName, {
          "fields": "id",
          "variables": JSON.stringify({where_key: where})
        });
        return data && data[Object.keys(data)].length > 0
      }
    },
    async processPermission() {
      var permissionName = 'role_permission';
      var count = 0;
      // xoá tất cả các quyền đã thêm trước đó
      if (this.modelPermissionData && this.roleID > 0) {
        var variables = {
          where_key: {
            role_id: {'_eq': this.roleID}
          }
        }
        await DataServices.deleteData(permissionName, {"variables": JSON.stringify(variables)});
      }
      var params = [];
      var roleIDTemp = this.roleID;
      var ordering = 0;
      var that = this;
      if (this.permissonAllWeb && this.permissonAllWeb.length) {
        this.permissonAllWeb.forEach(function (value, index) {
          ordering++;
          if (value) {
            params.push({
              role_id: roleIDTemp,
              permission_id: index,
              ordering: ordering,
              created_date: that.$myConstants.currentDate(),
              modified_date: that.$myConstants.currentDate(),
              status: 1
            });
          }
        });
      }
      if (this.permissonAllMobile && this.permissonAllMobile.length) {
        this.permissonAllMobile.forEach(function (value, index) {
          ordering++;
          if (value) {
            params.push({
              role_id: roleIDTemp,
              permission_id: index,
              ordering: ordering,
              created_date: that.$myConstants.currentDate(),
              modified_date: that.$myConstants.currentDate(),
              status: 1
            });
          }
        });
      }
      if (params && params.length) {
        var dataInsert = await DataServices.insertData(permissionName, {"variables": JSON.stringify({objects: params})});
        if (dataInsert && Object.keys(dataInsert).length) count = 1;
      } else count = 1;

      if (count > 0) {
        this.$store.commit('setLoading', false);
        this.$toast.add({severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000})
        setTimeout(() => {
          this.$router.push({path: '/admin/role'});
        }, 500);
      }
    },
    async getCodeNext() {
      var data = await DataServices.getObjectData('service_park', {}, {id: 'desc'});
      if (!this.$myConstants.isEmpty(data)) {
        var codeLast = data.code;
        var codeRightLast = codeLast.substring((codeLast.length - 6));//Cắt lấy 6 ký tự cuối cùng
        var codeRightTmp = (parseInt(codeRightLast) + 1).toString();
        return 'GDV' + codeRightTmp.padStart(6, '0');
      }
      return 'GDV000001';
    },
    async validationData() {
      var vm =this;
      this.validationErrors = {};
      if (this.$myConstants.isEmpty(this.objectData.code)) {
        this.validationErrors['code'] = 'Nhập mã gói dịch vụ';
      }else {
        var where_check_code = { code: {'_ilike': this.objectData.code} }
        if (this.formMode === 'edit'){
          where_check_code.id = {_neq: this.$route.params.id};
        }
        var check_code =await DataServices.getObjectData('service_park',where_check_code,null);
        if (!vm.$myConstants.isEmpty(check_code)){
          vm.validationErrors['code'] = 'Mã gói dịch vụ đã tồn tại';//Trùng
        }
      }

      if (this.$myConstants.isEmpty(this.objectData.name)) {
        this.validationErrors['name'] = 'Nhập tên gói dịch vụ';
      }else {
        var where_check_name = { name: {'_ilike': this.objectData.name} }
        if (this.formMode === 'edit'){
          where_check_name.id = {_neq: this.$route.params.id};
        }
        var check_name =await DataServices.getObjectData('service_park',where_check_name,null);
        if (!vm.$myConstants.isEmpty(check_name)){
          vm.validationErrors['name'] = 'Tên gói dịch vụ đã tồn tại';//Trùng tên goi dv
        }
      }

      if (this.listDataServiceSupplies.length < 1){
        vm.validationErrors['list_service_supplies'] = 'Vui lòng thêm vật tư - dịch vụ sửa chữa vào danh sách';
      }
      if (this.objectData.apply_all_model == '0'){
        if (this.listModelProduct.listData.length < 1){
          vm.validationErrors['list_product'] = 'Vui lòng thêm model sản phẩm áp dụng cho gói dịch vụ vào danh sách';
        }
      }

      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    async saveData() {
      var vm = this;
      this.submitForm = true;
      await this.validationData();
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      if (Object.entries(this.validationErrors).length === 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var params = {
          'code': this.objectData.code,
          'name': this.objectData.name,
          'description': this.objectData.description,
          'modified_date': this.$myConstants.currentDate(),
          'apply_all_model': parseFloat(this.objectData.apply_all_model),
          'status': this.objectData.status ? 1 : 0,
          'modifier_id': this.$store.getters.fullname.id
        }
        //Lấy gói vật tư
        var list_service_supplies_insert = [];
        var list_service_supplies_id = [];
        for (var s = 0; s < this.listDataServiceSupplies.length; s++) {
          var data_i_service_supplies = {
            service_supplier_id: this.listDataServiceSupplies[s].id,
            status: 1,
            created_date: this.$myConstants.currentDate(),
            modified_date: this.$myConstants.currentDate(),
          }
          list_service_supplies_id.push(this.listDataServiceSupplies[s].id);
          if (this.formMode == 'edit') {
            //loại những vật tư cũ
            if (vm.listOldServiceSupplies.indexOf(parseFloat(this.listDataServiceSupplies[s].id)) == -1) {
              data_i_service_supplies.service_pack_id = this.$route.params.id;
              list_service_supplies_insert.push(data_i_service_supplies);
            }
          } else {
            list_service_supplies_insert.push(data_i_service_supplies);
          }
        }
        list_service_supplies_insert = (list_service_supplies_insert.length>0) ? list_service_supplies_insert.reverse():[];//đảo ngược mạng để thêm item vào đúng thức tự


        //Lấy model sản phẩm
        var list_model_product_insert = [];
        var list_model_product_id = [];
        if (parseFloat(this.objectData.apply_all_model) == 0) {
          for (var p = 0; p < this.listModelProduct.listData.length; p++) {
            var data_p_product = {
              product_id: this.listModelProduct.listData[p].id,
              status: 1,
              created_date: this.$myConstants.currentDate(),
              modified_date: this.$myConstants.currentDate(),
            }
            list_model_product_id.push(this.listModelProduct.listData[p].id);
            if (this.formMode == 'edit') {
              if (vm.listModelProduct.listOld.indexOf(parseFloat(this.listModelProduct.listData[p].id)) == -1) {
                data_p_product.service_pack_id = this.$route.params.id;
                list_model_product_insert.push(data_p_product);
              }
            } else {
              list_model_product_insert.push(data_p_product);
            }
          }
        }
        list_model_product_insert = (list_model_product_insert.length>0) ? list_model_product_insert.reverse():[];//đảo ngược mạng để thêm item vào đúng thức tự
        if (this.formMode == 'edit') {
          // await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.modelPermissionData.id }}})});
          var query_delete_service_supplies = ``;
          //update những vật tư cũ bị xóa
          if (list_service_supplies_id.length > 0) {
            query_delete_service_supplies = `
          update_core_service_pack_service_supplies(where: { service_pack_id: {_eq: ${this.$route.params.id}},service_supplier_id: {_nin: [${list_service_supplies_id.toString()}]}}, _set: {status: 0}) {
              affected_rows
              returning {
                id
              }
          }`
            ;
          }
          var query_delete_model_product = ``;
          //update model sản phẩm
          if (parseFloat(this.objectData.apply_all_model) == 0) {
            if (list_model_product_id.length > 0) {
              //update status 0 nếu bị xóa
              query_delete_model_product = `
              update_core_service_pack_product(where: { service_pack_id: {_eq: ${this.$route.params.id}},product_id: {_nin: [${list_model_product_id.toString()}]}}, _set: {status: 0}) {
                  affected_rows
                  returning {
                    id
                  }
              }`
              ;
            }
          } else {
            //bật all status=0
            query_delete_model_product = `
          update_core_service_pack_product(where: { service_pack_id: {_eq: ${this.$route.params.id}}}, _set: {status: 0}) {
              affected_rows
              returning {
                id
              }
          }`
            ;
          }
          var queryUpdate = `
        mutation update_service_pack_multil($core_service_pack_object: core_service_pack_set_input,$core_service_pack_service_supplies_upsert:[core_service_pack_service_supplies_insert_input!]!,$core_service_pack_product_upsert:[core_service_pack_product_insert_input!]!) {
          update_core_service_pack(where: { id: {_eq: "${this.$route.params.id}"}}, _set: $core_service_pack_object) {
            affected_rows
            returning {
              id
            }
          }
          ${query_delete_service_supplies}
          insert_core_service_pack_service_supplies (
              objects: $core_service_pack_service_supplies_upsert,
              on_conflict: {
                constraint: core_service_pack_service_supplies_pkey,
                update_columns: [service_supplier_id,service_pack_id,status,created_date,modified_date]
                }
              ) {
            returning {
              id
            }
          }
          ${query_delete_model_product}
          insert_core_service_pack_product (
              objects: $core_service_pack_product_upsert,
              on_conflict: {
                constraint: core_service_pack_product_pkey,
                update_columns: [service_pack_id,product_id,status,created_date,modified_date]
                }
              ) {
            returning {
              id
            }
          }
        }
          `;
          var variables = {
            "variables": JSON.stringify({
              core_service_pack_object: params,
              core_service_pack_service_supplies_upsert: list_service_supplies_insert,
              core_service_pack_product_upsert: list_model_product_insert
            })
          };
          DataServices.executeQuery(this.modelName, queryUpdate, variables).then(async () => {
            vm.$router.push({path: '/admin/service-park'});
          }).catch(async () => {
            vm.$toast.add({
              severity: 'error',
              summary: 'Thông báo',
              detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
              life: 3000
            });
            vm.submitForm = false;
          });
        } else {
          //params.code = await this.getCodeNext();
          //params.code = this.objectData.code;
          params = Object.assign(params, {'created_date': this.$myConstants.currentDate()});
          params = Object.assign(params, {'creator_organization_id': creator_organization_id});
          params.arr_service_pack_service_supplies = {data: this.$myConstants.convertJsonObject(list_service_supplies_insert)};
          params.arr_service_pack_product = {data: this.$myConstants.convertJsonObject(list_model_product_insert)};
          DataServices.insertData(this.modelName, {"variables": JSON.stringify({objects: params})}).then(async () => {
            vm.$router.push({path: '/admin/service-park'});
          }).catch(async () => {
            vm.$toast.add({
              severity: 'error',
              summary: 'Thông báo',
              detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
              life: 3000
            });
            vm.submitForm = false;
          });

        }
      } else this.submitForm = false;
    }
  }
}
</script>
<style lang="scss">
.box-top-list {
  border: 1px solid #ccc;
  padding: 10px;

  span {
    font-size: 25px;
    text-align: left;
    display: inline-block;
  }

  .right-button {
    float: right;

    span {
      font-size: 14px;
    }

    .p-button {
      border-radius: 5px;
      min-width: 100px;

      &.btn-custom {
        margin-left: 10px;
      }

      span {
        text-align: center;
      }
    }
  }
}

.list-data-permission {
  border: 1px solid #ccc;
  border-top: 0;

  .box-tabview {
    padding: 0.5em 1em;
    width: 100%;

    .row-item-header {
      div {
        display: inline-block;
        border: 1px solid #e9ecef;
        border-width: 1px 0 0 0;
        font-weight: 600;
        color: #495057;
        background: #f8f9fa;
        transition: box-shadow 0.2s;
        padding: 0.571rem 0.857rem;
      }
    }

    .row-body {
      .row-item {
        border: 1px solid #e9ecef;
        border-width: 1px 0 0 0;
        padding: 0.571rem 0.857rem;

        .item {
          display: inline-block;
          color: #495057;
          transition: box-shadow 0.2s;
        }
      }

      &:last-child {
        .row-item {
          &:last-child {
            border-bottom: 1px solid #e9ecef;
          }
        }
      }
    }
  }
}

.group_radio_button {
  margin-left: 30px;

  .radio_product_apply {
    position: relative;

    .radio_lable_product_apply {
      position: absolute;
      left: 30px;
      top: 3px;
    }
  }

  .p-radiobutton .p-radiobutton-box .p-radiobutton-icon{
    color: #007ad9;
  }
  .p-radiobutton .p-radiobutton-box.p-highlight{
    background: #ffffff;
  }
}

.box_add_option {
  background-color: rgba(242, 242, 242, 1);
  border-radius: 10px;
  margin: 0px;
  padding: 15px;

  .box_input {
    padding: 0px;
    width: calc(100% - 120px);

    .box_title {
      position: relative;
      height: 20px;
      margin-bottom: 2px;
      .title_input {
        font-size: 14px;
        position: absolute;
        left: 0px;
      }

      .add_service_supplies {
        font-size: 14px;
        position: absolute;
        right: 0px;
        font-family: 'Arial Italic', 'Arial';
        font-weight: 400;
        font-style: italic;
        cursor: pointer;
      }
    }
  }

  .add_btn_data {
    position: relative;
    width: 100px;
    height: 40px;
    background: inherit;
    background-color: rgba(0, 153, 255, 1);
    border: none;
    border-radius: 5px;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 20px;

    .style_icon_add {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      left: 0;
      bottom: 0;
      margin-left: 14px;
    }

    .style_text {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      bottom: 0;
      height: fit-content;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
    }
  }
}
.style_lable{
  font-weight: 700;
}
td.right_td_unit_price{
  text-align: right !important;
}
</style>

<style>
.list_service_supplies .p-datatable-auto-layout > .p-datatable-wrapper{
  overflow-x: unset !important;/*bỏ croll ngang table ảnh hưởng đến show dropdown lên*/
}
</style>